import moment from 'moment';
import React from 'react';
import { fromJS } from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage } from 'react-intl';
import * as _ from 'lodash';
import { uniqueId } from 'lodash';
import validator from 'validator';
import ReactResizeDetector from 'react-resize-detector';

import { removeTimeZoneFromDate } from 'utils/dateUtil';
import FlexBox from 'components/FlexBox';
import TimePickerInput from 'components/TimePickerInput';
import injectReducer from 'utils/injectReducer';
import { makeSelectStepCancellationAdditional, makeSelectStepCancellationAdditionalErrors } from './selectors';
import reducer from './reducer';
import PageSectionHeader from '../components/PageSectionHeader';
import { Button } from '../components/Button';
import messages from './messages';
import {
  handleFormDataChange,
  nextSlide,
  resetFormCancellationAmendmentExpense,
  resetFormCompensationExpense,
  resetFormData,
  resetFormTravelDelayExpenses,
  resetAdditionalExpense,
} from './actions';
import OptionsContainer from '../components/OptionsContainer';
import Section from '../components/Section';
import TextArea from '../components/TextArea';
// import '../assets/style.css';
import { CancellationExpensesList } from './components/CancellationExpenses';
import { AdditionalExpensesList } from './components/AdditionalExpenses';
import { DelayedTravelExpensesList } from './components/DelayedTravelExpenses';
import DatePicker from '../components/DatePicker';
import { required } from '../../../utils/validation/validator';
import {
  ErrorMessage,
  Validate,
  ValidateGroup,
} from '../../../components/Validation';
import HelpText from '../../../components/HelpText';
import { saveFormData, emailMeDocument } from '../actions';
import groupOption from '../../../components/Validation/groupOption';
import Textbox from '../components/Textbox';

import {
  RESET_CANCELLATION_AMENDMENT,
  RESET_COMPENSATION,
  RESET_TRAVEL_DELAY,
  RESET_ADDITIONAL,
} from './constants';
import { makeSelectCurrentStep } from '../../Wizard/selectors';
import { makeSelectProgressBarStatus } from '../../ProgressBar/selectors';
import AsyncButton from '../../../components/AsyncButton/index';
import { stepCancellationAdditionalExpenseLookup } from '../../FastCover/dataMapper/claimCodeMapper';
import { makeSelectMedicalCertificateFormLink, makeSelectMedicalAuthorityFormLink } from '../../App/selectors';
import CurrencySelector from '../components/CurrencySelector';

export class StepCancellationAdditional extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      validationCounter: 0,
      errors: [],
    };
    this.validatorGroup = new ValidateGroup();
    this.handleNext = this.handleNext.bind(this);
    this.onCancellationExpensesChange = this.onCancellationExpensesChange.bind(
      this
    );
    this.onAdditionalExpensesChange = this.onAdditionalExpensesChange.bind(
      this
    );
    this.onDelayedTravelExpensesChange = this.onDelayedTravelExpensesChange.bind(
      this
    );
    this.checkFormError = this.checkFormError.bind(this);
    this.onResize = this.onResize.bind(this);

    this.saveButtonId = uniqueId();
    this.emailMeDocumentButton = uniqueId();
    this.clickedItemId = '';
    this.nextButton = null;
  }

  componentWillReceiveProps(nextProps) {
    const { currentStep, step, stepName } = this.props;
    if ((stepName && nextProps.validateStep === stepName) || (currentStep !== nextProps.currentStep && currentStep === step)) {
      this.checkFormError();
    }

    if (this.props.isReadOnly && nextProps.errors !== this.props.errors) {
      this.state.validationCounter += 1;
      this.validatorGroup.checkValidation();
    }

    if (!nextProps.loading) {
      this.clickedItemId = '';
    }
  }

  onCancellationExpensesChange = (data) => {
    this.props.onFormDataChange('form.cancellationExpenses', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onAdditionalExpensesChange = (data) => {
    this.props.onFormDataChange('form.additionalExpenses', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onDelayedTravelExpensesChange = (data) => {
    this.props.onFormDataChange('form.delayedTravelExpenses', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onChange = (propertyName) => (event) => {
    if (event === null) {
      this.props.onFormDataChange(propertyName, null);
      return;
    }

    if (event.constructor.name === 'Moment') {
      this.props.onFormDataChange(propertyName, removeTimeZoneFromDate(event.toDate().toString()));
    } else {
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      if (target.type === 'radio') {
        this.props.adjust();
      }
      this.props.onFormDataChange(propertyName, value);
    }
    // this.props.makeDirty(5);
  };

  onDayChange = (propertyName) => (day) => {
    const localDate = removeTimeZoneFromDate(day);
    this.props.onFormDataChange(propertyName, localDate);
    // this.props.makeDirty(5);
  };


  onInputComponentChange = (propertyName) => (event) => {
    if (event.target.checked) {
      const selectedValue = this.getSelectedReason();

      this.props.adjust();

      if (!!selectedValue && selectedValue !== propertyName) {
        this.props.onFormDataChange(`form.${selectedValue}`, 'false');
      }
    }
    this.onChange(`form.${propertyName}`)(event);
    // this.props.makeDirty(5);
  };

  onResize = () => {
    const { adjust } = this.props;
    if (adjust) {
      adjust();
    }
  };

  getValidationErrors() {
    const {
      cancellationExpenses,
      additionalExpenses,
      delayedTravelExpenses,
    } = this.props.form;
    const selectedReason = this.getSelectedReason();
    const errors = [];

    switch (selectedReason) {
      case this.REASON.TRIP_CANCELLATION_EXPENSES:
      case this.REASON.ALTERNATIVE_TRANSPORT_EXPENSES:
      case this.REASON.TRIP_RESUMPTION_EXPENSES:
      case this.REASON.TRIP_DISRUPTION_OR_ADDITIONAL_EXPENSES:
        if (this.validateTableField(cancellationExpenses)) {
          errors.push({
            field: 'cancellationExpense',
            message: 'Cancellation Expense table fields are required fields.',
          });
        }
        if (this.validateTableField(additionalExpenses)) {
          errors.push({
            field: 'additionalExpense',
            message: 'Additional Expenses table fields are required fields.',
          });
        }
        break;
      case this.REASON.DELAY:
        if (this.validateTableField(delayedTravelExpenses)) {
          errors.push({
            field: 'delayedTravelExpense',
            message:
              'Delayed Travel Expenses table fields are required fields.',
          });
        }
        break;
      default:
        break;
    }

    return errors;
  }

  getCheckboxGroupComponent = (field, value, isChecked) => {
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;
    return (
      <input
        disabled={isReadOnly}
        type="radio"
        checked={isChecked}
        onChange={this.onInputComponentChange(field)}
        value={value}
      />
    );
  };

  getSelectedReason = () => {
    const {
      claimForTripCancellationExpenses,
      claimForTripDisruptionOrAdditionalExpenses,
      claimForTripResumptionExpenses,
      claimForAlternativeTransportExpenses,
      claimForATravelDelay,
    } = this.props.form;

    let selectedValue = null;

    switch ('true') {
      case claimForTripCancellationExpenses:
        selectedValue = this.REASON.TRIP_CANCELLATION_EXPENSES;
        break;
      case claimForTripDisruptionOrAdditionalExpenses:
        selectedValue = this.REASON.TRIP_DISRUPTION_OR_ADDITIONAL_EXPENSES;
        break;
      case claimForTripResumptionExpenses:
        selectedValue = this.REASON.TRIP_RESUMPTION_EXPENSES;
        break;
      case claimForAlternativeTransportExpenses:
        selectedValue = this.REASON.ALTERNATIVE_TRANSPORT_EXPENSES;
        break;
      case claimForATravelDelay:
        selectedValue = this.REASON.DELAY;
        break;
      default:
        selectedValue = null;
        break;
    }

    return selectedValue;
  };

  handleSaveButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.onFormDataSave();
    this.nextButton.focus(); // make focus next button and handle tab key press
  };

  handleEmailMeButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.emailMeDocument();
  };

  showSpinnerForElement = (elementId) => this.clickedItemId === elementId;

  checkFormError() {
    const valid = this.validatorGroup.checkValidation();
    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }
  }

  handlePartialFormReset = (section, field) => (event) => {
    switch (section) {
      case RESET_TRAVEL_DELAY:
        this.props.onResetTravelDelayExpense();
        break;
      case RESET_CANCELLATION_AMENDMENT:
        this.props.onResetCancellationExpense();
        break;
      case RESET_COMPENSATION:
        this.props.onResetCompensationExpense();
        break;
      case RESET_ADDITIONAL:
        this.props.resetAdditionalExpense();
        break;
      default:
        break;
    }

    this.onChange(field)(event);
  };

  handleKeyDown = (e) => {
    if (e.shiftKey && e.key === 'Tab') {
      return;
    }
    if (e.key === 'Tab') {
      e.preventDefault();
    }
  };

  REASON = {
    TRIP_CANCELLATION_EXPENSES: 'claimForTripCancellationExpenses',
    TRIP_DISRUPTION_OR_ADDITIONAL_EXPENSES:
      'claimForTripDisruptionOrAdditionalExpenses',
    TRIP_RESUMPTION_EXPENSES: 'claimForTripResumptionExpenses',
    ALTERNATIVE_TRANSPORT_EXPENSES: 'claimForAlternativeTransportExpenses',
    DELAY: 'claimForATravelDelay',
  };

  shouldDisable = (field) => {
    const selectedValue = this.getSelectedReason();

    return !!selectedValue && selectedValue !== field;
  };

  appendIds = (array) =>
    array.map((item) => {
      let newItem = item; // eslint-disable-line

      if (!item.id) {
        newItem.id = new Date().getTime().toString();
      }

      return newItem;
    });

  handleNext = () => {
    const { submitted } = this.props;
    if (submitted) {
      this.props.next();
      return;
    }

    const valid = this.validatorGroup.checkValidation();
    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }

    this.props.onFormDataSave();
    this.props.next();
  };

  handleFormDataSave = () => {
    this.props.onFormDataSave();
  };

  handleCancellationAmendmentOption = (event) => {
    // when the CancellationAmendmentOrDelay options is selected
    // we need to make claimForTripCancellationExpenses as default option.
    this.onChange('form.claimForCancellationAmendmentOrDelay')(event);
    this.onChange('form.claimForTripCancellationExpenses')(event);
  };

  validateTableField(groups) {
    const invalid = _.some(groups, (fields) =>
      _.some(fields, (value) => {
        const newValue = value ? value.toString() : '';
        return validator.isEmpty(newValue);
      })
    );
    return invalid;
  }

  summaryFormValue() {
    return _.mapValues(this.props.form, (prop) => prop || 'N/A');
  }
  handleCurrencyChange = (propertyName) => (value) => {
    this.props.onFormDataChange(propertyName, value);
  }
  renderCancellationExpensesForm() {
    const { isSummary, submitted, medicalAuthorityFormLink, medicalCertificateFormLink } = this.props;
    const {
      reasonForCancellationOrAmendment,
      cancellationExpenses,
      enableTime,
    } = isSummary ? this.summaryFormValue() : this.props.form;
    const isReadOnly = submitted || isSummary;
    // list need id to be used as identity
    const newCancellationExpenses = this.appendIds(cancellationExpenses);
    const buttonEmailMeDisable = !!enableTime && new Date().getTime() < enableTime;
    return (
      <div className="ml-4">
        <Section>
          <Validate
            validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
            name="reasonForCancellationOrAmendment"
            group={this.validatorGroup}
            validators={[required]}
            addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
            validChangeInGroup={this.validatorGroup.validChangeInGroup}
            validationCounter={this.state.validationCounter}
            defaultValue={groupOption(reasonForCancellationOrAmendment)}
            fieldName={messages.reasonForCancellationOrAmendment}
            onChangeValueKeys={[groupOption(reasonForCancellationOrAmendment)]}
          >
            <FlexBox direction="column">
              <OptionsContainer>
                <div>
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="medical"
                    checked={reasonForCancellationOrAmendment.medical === true}
                    onChange={this.onChange(
                    'form.reasonForCancellationOrAmendment.medical'
                  )}
                  />
                </div>
                <span>
                Medical reasons (illness or injury) - We may need the injured/ill person to complete <a className="font-weight-bold" href={medicalAuthorityFormLink} target="_blank"> our Medical Authority Form</a> and their usual GP/Specialist to complete <a className="font-weight-bold" href={medicalCertificateFormLink} target="_blank">
                our Medical Certificate Form</a>.
                &nbsp;<AsyncButton
                  id={this.emailMeDocumentButton}
                  className="btn-noOutline"
                  disabled={buttonEmailMeDisable || isReadOnly}
                  loading={this.props.loading}
                  spinner={this.showSpinnerForElement(this.emailMeDocumentButton)}
                  onClick={this.handleEmailMeButtonClick}
                >
                  Email me these forms
                </AsyncButton>
                </span>
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  name="travel"
                  checked={reasonForCancellationOrAmendment.travel === true}
                  onChange={this.onChange(
                    'form.reasonForCancellationOrAmendment.travel'
                  )}
                />
                <span>
                  <FormattedMessage {...messages.travel} />
                </span>
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  name="redundancy"
                  checked={reasonForCancellationOrAmendment.redundancy === true}
                  onChange={this.onChange(
                    'form.reasonForCancellationOrAmendment.redundancy'
                  )}
                />
                <span>
                  <FormattedMessage {...messages.redundancy} />
                </span>
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  name="other"
                  checked={reasonForCancellationOrAmendment.other === true}
                  onChange={this.onChange(
                    'form.reasonForCancellationOrAmendment.other'
                  )}
                />
                <span>
                  <FormattedMessage {...messages.other} />
                </span>
              </OptionsContainer>
            </FlexBox>
            <ErrorMessage for="required">
              &apos;Reason for cancellation/amendment&apos; is required
            </ErrorMessage>
          </Validate>
        </Section>
        <Section>
          <FlexBox>
            <TextArea
              disabled={isReadOnly}
              value={reasonForCancellationOrAmendment.otherDescription}
              onChange={this.onChange(
                'form.reasonForCancellationOrAmendment.otherDescription'
              )}
              isSummary={isSummary}
            />
          </FlexBox>
        </Section>
        <Section>
          <PageSectionHeader>
            <FormattedMessage {...messages.cancellationExpenses} />
          </PageSectionHeader>
          <FlexBox>
            <CancellationExpensesList
              data={newCancellationExpenses}
              onChange={this.onCancellationExpensesChange}
              disabled={isReadOnly}
              validatorGroup={this.validatorGroup}
              validationCounter={this.state.validationCounter}
            />
          </FlexBox>
        </Section>
      </div>
    );
  }

  renderCancellationExpenses() {
    const { claimForCancellationAmendmentOrDelay } = this.props.form;

    if (claimForCancellationAmendmentOrDelay === 'true') {
      // render content
      return (
        <Section>
          {this.renderCancellationExpensesForm()}
        </Section>
      );
    }

    // render nothing;
    return null;
  }

  renderAdditionalExpenses() {
    const { isSummary, submitted } = this.props;
    const {
      additionalExpenses,
      areThereAnyAdditionalExpensesToBeClaimed,
    } = isSummary ? this.summaryFormValue() : this.props.form;
    const isReadOnly = submitted || isSummary;
    const isRenderAdditionalExpense = !!stepCancellationAdditionalExpenseLookup.claimForAdditionalExpenses.claimCode;
    // list need id to be used as identity
    const newAdditionalExpenses = this.appendIds(additionalExpenses);

    if (!isRenderAdditionalExpense) {
      return null;
    }

    return (
      <div>
        {isRenderAdditionalExpense && (
          <Section>
            <PageSectionHeader>
              <FormattedMessage
                {...messages.areThereAnyAdditionalExpensesToBeClaimed}
              />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  checked={areThereAnyAdditionalExpensesToBeClaimed === 'true'}
                  onChange={this.onChange(
                    'form.areThereAnyAdditionalExpensesToBeClaimed'
                  )}
                  value="true"
                />
                <FormattedMessage {...messages.yes} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  checked={areThereAnyAdditionalExpensesToBeClaimed === 'false'}
                  onChange={this.handlePartialFormReset(
                    RESET_ADDITIONAL,
                    'form.areThereAnyAdditionalExpensesToBeClaimed'
                  )}
                  value="false"
                />
                <FormattedMessage {...messages.no} />
              </OptionsContainer>
            </FlexBox>
          </Section>
        )}

        {isRenderAdditionalExpense &&
          areThereAnyAdditionalExpensesToBeClaimed === 'true' && (
            <div className="ml-4">
              <Section>
                <b>
                  <FormattedMessage {...messages.additionalExpenses} />
                </b>
                <FlexBox>
                  <AdditionalExpensesList
                    data={newAdditionalExpenses}
                    onChange={this.onAdditionalExpensesChange}
                    disabled={isReadOnly}
                    validatorGroup={this.validatorGroup}
                    validationCounter={this.state.validationCounter}
                  />
                </FlexBox>
              </Section>
            </div>
          )}
      </div>
    );
  }

  renderTravelDelayForm() {
    const { isSummary, submitted } = this.props;

    const {
      delayedTravelReason,
      departDate,
      departTime,
      departedDate,
      departedTime,
      receivedCompensation,
      delayedTravelExpenses,
      amountOfCompensation,
      amountOfCompensationCurrency,
      dateCompensationWasReceived,
      compensationDescription,
    } = isSummary ? this.summaryFormValue() : this.props.form;
    const isReadOnly = submitted || isSummary;

    const newDepartTime = departTime ? moment(departTime) : null;
    const newDepartedTime = departedTime ? moment(departedTime) : null;

    // list need id to be used as identity
    const newDelayedTravelExpenses = this.appendIds(delayedTravelExpenses);

    return (
      <div>
        <div className="ml-4">
          {/* <PageSectionHeader>*/}
          {/* <FormattedMessage {...messages.delayedTravelTitle} />*/}
          {/* </PageSectionHeader>*/}
          <div className="row">
            <div className="form-group col">
              <Validate
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                name="delayedTravelReason"
                group={this.validatorGroup}
                validators={[required]}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                defaultValue={delayedTravelReason}
                fieldName={messages.whatWasTheReasonForYourDelay}
              >
                <TextArea
                  name="delayedTravelReason"
                  value={delayedTravelReason}
                  onChange={this.onChange('form.delayedTravelReason')}
                  disabled={isReadOnly}
                  isSummary={isSummary}
                />
                <ErrorMessage for="required">
                  &apos;What was the reason for your delay?&apos; is a required
                  field.
                </ErrorMessage>
              </Validate>
            </div>
          </div>

          <div className="row">
            <div className="form-group col-md-6 col-sm-6">
              <Validate
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                name="departDate"
                group={this.validatorGroup}
                validators={[required]}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                defaultValue={departDate}
                fieldName={messages.dateYouWereDueToDepart}
              >
                <DatePicker
                  disabled={isReadOnly}
                  type="text"
                  onDayChange={this.onDayChange('form.departDate')}
                  value={departDate}
                  placeholder="dd/mm/yyyy"
                />
                <ErrorMessage for="required">
                  &apos;Date you were due to depart&apos; is a required field.
                </ErrorMessage>
              </Validate>
            </div>
            <div className="form-group col-md-6 col-sm-6">
              <Validate
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                name="departTime"
                group={this.validatorGroup}
                validators={[required]}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                className="w-full"
                defaultValue={newDepartTime}
                fieldName={messages.timeYouWereDueToDepart}
              >
                <TimePickerInput
                  allowEmpty
                  showSecond={false}
                  onChange={this.onChange('form.departTime')}
                  value={newDepartTime}
                  placeholder="hh:mm"
                  disabled={isReadOnly}
                />
                <ErrorMessage for="required">
                  &apos;Time you were due to depart&apos; is a required field.
                </ErrorMessage>
              </Validate>
            </div>
          </div>

          <div className="row">
            <div className="form-group col-md-6 col-sm-6">
              <Validate
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                name="departedDate"
                group={this.validatorGroup}
                validators={[required]}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                defaultValue={departedDate}
                fieldName={messages.dateYouActuallyDeparted}
              >
                <DatePicker
                  disabled={isReadOnly}
                  type="text"
                  onDayChange={this.onDayChange('form.departedDate')}
                  value={departedDate}
                  placeholder="dd/mm/yyyy"
                />
                <ErrorMessage for="required">
                  &apos;Date you actually departed&apos; is a required field.
                </ErrorMessage>
              </Validate>
            </div>
            <div className="form-group col-md-6 col-sm-6">
              <PageSectionHeader>
                <FormattedMessage {...messages.timeYouActuallyDeparted} />
              </PageSectionHeader>

              <TimePickerInput
                allowEmpty
                showSecond={false}
                onChange={this.onChange('form.departedTime')}
                value={newDepartedTime}
                placeholder="hh:mm"
                disabled={isReadOnly}
              />
            </div>
          </div>

          <div className="row">
            <div className="form-group col">
              <PageSectionHeader>
                <FormattedMessage
                  {...messages.didYouReceiveAnyCompensationFromYourTravelProvider}
                />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    checked={receivedCompensation === 'true'}
                    onChange={this.onChange('form.receivedCompensation')}
                    value="true"
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    checked={receivedCompensation === 'false'}
                    onChange={this.handlePartialFormReset(
                      RESET_COMPENSATION,
                      'form.receivedCompensation'
                    )}
                    value="false"
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
              <HelpText>
                <FormattedMessage
                  {...messages.didYouReceiveAnyCompensationFromYourTravelProviderTextNote}
                />
              </HelpText>
            </div>
          </div>
          {receivedCompensation === 'true' && (
            <div className="ml-4">
              <div className="row">
                <div className="form-group col-sm-4 mb02">
                  <PageSectionHeader>
                    <FormattedMessage
                      {...messages.dateCompensationWasReceived}
                    />
                  </PageSectionHeader>
                  <DatePicker
                    disabled={isReadOnly}
                    type="text"
                    onDayChange={this.onDayChange(
                      'form.dateCompensationWasReceived'
                    )}
                    value={dateCompensationWasReceived}
                    placeholder="dd/mm/yyyy"
                  />
                </div>
                <div className="form-group col-sm-4 mb02">
                  <PageSectionHeader>
                    <FormattedMessage {...messages.amountOfCompensation} />
                  </PageSectionHeader>
                  <Textbox
                    disabled={isReadOnly}
                    name="amountOfCompensation"
                    type="number"
                    value={amountOfCompensation}
                    onChange={this.onChange('form.amountOfCompensation')}
                  />
                </div>
                <div className="form-group col-sm-4 mb02">
                  <PageSectionHeader>
                    <FormattedMessage
                      {...messages.amountOfCompensationCurrency}
                    />
                  </PageSectionHeader>

                  <CurrencySelector
                    name="amountOfCompensationCurrency"
                    disabled={isReadOnly}
                    value={amountOfCompensationCurrency}
                    onChange={this.handleCurrencyChange(
                      'form.amountOfCompensationCurrency'
                    )}
                  />
                  <HelpText>
                    <FormattedMessage {...messages.currencyEg} />
                  </HelpText>
                </div>
              </div>
              <div className="row">
                <div className="form-group col-sm-12">
                  <PageSectionHeader>
                    <FormattedMessage {...messages.compensationDescription} />
                  </PageSectionHeader>
                  <Textbox
                    disabled={isReadOnly}
                    name="compensationDescription"
                    value={compensationDescription}
                    onChange={this.onChange('form.compensationDescription')}
                  />
                </div>
              </div>
            </div>
          )}

          <div>
            <PageSectionHeader>
              <FormattedMessage {...messages.delayedTravelExpenses} />
            </PageSectionHeader>
            <FlexBox>
              <DelayedTravelExpensesList
                data={newDelayedTravelExpenses}
                onChange={this.onDelayedTravelExpensesChange}
                disabled={isReadOnly}
                validatorGroup={this.validatorGroup}
                validationCounter={this.state.validationCounter}
              />
            </FlexBox>
          </div>
        </div>
      </div>
    );
  }

  renderTravelDelay() {
    const { claimForATravelDelay } = this.props.form;

    if (claimForATravelDelay === 'true') {
      // render content
      return <div>{this.renderTravelDelayForm()}</div>;
    }

    // render nothing;
    return null;
  }

  renderCancellationSubbenefits = () => {
    const { isSummary } = this.props;
    const {
      claimForCancellationAmendmentOrDelay,
      claimForTripCancellationExpenses,
      claimForTripDisruptionOrAdditionalExpenses,
      claimForTripResumptionExpenses,
      claimForAlternativeTransportExpenses,
    } = isSummary ? this.summaryFormValue() : this.props.form;

    if (claimForCancellationAmendmentOrDelay === 'false') {
      return null;
    }

    const subbenefits = [
      {
        heading: { ...messages.areYouClaimingForTripCancellationExpenses },
        field: Object.keys({ claimForTripCancellationExpenses })[0],
        checked: claimForTripCancellationExpenses,
      },
      {
        heading: {
          ...messages.areYouClaimingForTripDisruptionOrAdditionalExpenses,
        },
        field: Object.keys({ claimForTripDisruptionOrAdditionalExpenses })[0],
        checked: claimForTripDisruptionOrAdditionalExpenses,
      },
      {
        heading: { ...messages.areYouClaimingForTripResumptionExpenses },
        field: Object.keys({ claimForTripResumptionExpenses })[0],
        checked: claimForTripResumptionExpenses,
      },
      {
        heading: { ...messages.areYouClaimingForAlternativeTransportExpenses },
        field: Object.keys({ claimForAlternativeTransportExpenses })[0],
        checked: claimForAlternativeTransportExpenses,
      },
    ];

    const benefitRadioButtons = subbenefits.map(
      (benefit) => (
        <Section>
          <PageSectionHeader>
            <FormattedMessage {...benefit.heading} />
          </PageSectionHeader>
          <FlexBox>
            <OptionsContainer>
              {this.getCheckboxGroupComponent(
                `${benefit.field}`,
                'true',
                benefit.checked === 'true'
              )}
              <FormattedMessage {...messages.yes} />
            </OptionsContainer>
            <OptionsContainer>
              {this.getCheckboxGroupComponent(
                `${benefit.field}`,
                'false',
                benefit.checked === 'false'
              )}
              <FormattedMessage {...messages.no} />
            </OptionsContainer>
          </FlexBox>
        </Section>
      ),
      this
    );

    return <div className="ml-4">{benefitRadioButtons}</div>;
  };

  render() {
    const {
      claimForCancellationAmendmentOrDelay,
      claimForATravelDelay,
    } = this.props.form;
    const { isSummary, submitted, loading } = this.props;
    const isReadOnly = submitted || isSummary;
    const isRenderClaimForTripCancellationExpenses = !!stepCancellationAdditionalExpenseLookup.claimForTripCancellationExpenses.claimCode;
    const isRenderAdditionalExpenses = !!stepCancellationAdditionalExpenseLookup.claimForAdditionalExpenses.claimCode;
    const isRenderClaimForATravelDelay = !!stepCancellationAdditionalExpenseLookup.claimForATravelDelay.claimCode;

    return (
      <div className="app-content">
        {isRenderClaimForTripCancellationExpenses && <Section>
          <PageSectionHeader>
            <FormattedMessage
              {...messages.areYouClaimingForCancellationAmendmentOrDelay}
            />
          </PageSectionHeader>
          <FlexBox>
            <OptionsContainer>
              <input
                disabled={isReadOnly}
                type="radio"
                checked={claimForCancellationAmendmentOrDelay === 'true'}
                onChange={this.handleCancellationAmendmentOption}
                value="true"
              />
              <FormattedMessage {...messages.yes} />
            </OptionsContainer>
            <OptionsContainer>
              <input
                disabled={isReadOnly}
                type="radio"
                checked={claimForCancellationAmendmentOrDelay === 'false'}
                onChange={this.handlePartialFormReset(
                  RESET_CANCELLATION_AMENDMENT,
                  'form.claimForCancellationAmendmentOrDelay'
                )}
                value="false"
              />
              <FormattedMessage {...messages.no} />
            </OptionsContainer>
          </FlexBox>
        </Section>}
        {/* {this.renderCancellationSubbenefits()} */}
        {isRenderClaimForTripCancellationExpenses && this.renderCancellationExpenses()}

        {isRenderAdditionalExpenses && this.renderAdditionalExpenses()}

        {isRenderClaimForATravelDelay && <Section>
          <PageSectionHeader>
            <FormattedMessage {...messages.areYouClaimingForATravelDelay} />
          </PageSectionHeader>
          <FlexBox>
            <OptionsContainer>
              <input
                disabled={isReadOnly}
                type="radio"
                checked={claimForATravelDelay === 'true'}
                onChange={this.onChange('form.claimForATravelDelay')}
                value="true"
              />
              <FormattedMessage {...messages.yes} />
            </OptionsContainer>
            <OptionsContainer>
              <input
                disabled={isReadOnly}
                type="radio"
                checked={claimForATravelDelay === 'false'}
                onChange={this.handlePartialFormReset(
                  RESET_TRAVEL_DELAY,
                  'form.claimForATravelDelay'
                )}
                value="false"
              />
              <FormattedMessage {...messages.no} />
            </OptionsContainer>
          </FlexBox>
        </Section>
        }
        {isRenderClaimForATravelDelay && this.renderTravelDelay()}

        {!isSummary && (
          <div className={'row justify-content-between'}>
            <div className={'col-12 col-sm-auto'}>
              <div className={'row'}>
                <div className={'col-12 col-sm-auto'}>
                  <button
                    className="btn-outline"
                    onClick={this.props.prev}
                    onKeyDown={this.handleKeyDown}
                  >
                    Back
                  </button>
                </div>
                <div className={'col-12 col-sm-auto'}>
                  <Button
                    onClick={this.handleNext}
                    onKeyDown={this.handleKeyDown}
                    innerRef={(ref) => {
                      this.nextButton = ref;
                    }}
                  >
                    Next &gt;
                  </Button>
                </div>
              </div>
            </div>
            <div className={'col-12 col-sm-auto'}>
              {!submitted && (
                <AsyncButton
                  id={this.saveButtonId}
                  className="btn-outline"
                  loading={loading}
                  spinner={this.showSpinnerForElement(this.saveButtonId)}
                  onClick={this.handleSaveButtonClick}
                  onKeyDown={this.handleKeyDown}
                >
                  Save
                </AsyncButton>
              )}
            </div>
          </div>
        )}
        <ReactResizeDetector handleHeight onResize={this.onResize} />
      </div>
    );
  }
}

StepCancellationAdditional.propTypes = {
  form: PropTypes.object,
  onFormDataChange: PropTypes.func,
  next: PropTypes.func,
  prev: PropTypes.func,
  onFormDataSave: PropTypes.func,
  isReadOnly: PropTypes.bool,
  adjust: PropTypes.func,
  onResetCancellationExpense: PropTypes.func,
  onResetTravelDelayExpense: PropTypes.func,
  onResetCompensationExpense: PropTypes.func,
  loading: PropTypes.bool,
  isSummary: PropTypes.bool,
  submitted: PropTypes.bool,
  currentStep: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  step: PropTypes.number,
  errors: PropTypes.any,
  onNext: PropTypes.func,
  makeError: PropTypes.func,
  makeValid: PropTypes.func,
  resetAdditionalExpense: PropTypes.func,
  emailMeDocument: PropTypes.func,
  validateStep: PropTypes.string,
  stepName: PropTypes.string,
  medicalAuthorityFormLink: PropTypes.any,
  medicalCertificateFormLink: PropTypes.any,
};

const mapStateToProps = createStructuredSelector({
  form: makeSelectStepCancellationAdditional(),
  errors: makeSelectStepCancellationAdditionalErrors(),
  currentStep: makeSelectCurrentStep(),
  loading: makeSelectProgressBarStatus(),
  medicalAuthorityFormLink: makeSelectMedicalAuthorityFormLink(),
  medicalCertificateFormLink: makeSelectMedicalCertificateFormLink(),
});

const mapDispatchToProps = (dispatch) => ({
  onFormDataChange: (propertyName, value) =>
    dispatch(handleFormDataChange(propertyName, value)),
  onFormDataSave: () => dispatch(saveFormData()),
  onNext: (errors) => dispatch(nextSlide(errors)),
  onReset: () => dispatch(resetFormData()),
  onResetCancellationExpense: () =>
    dispatch(resetFormCancellationAmendmentExpense()),
  onResetTravelDelayExpense: () => dispatch(resetFormTravelDelayExpenses()),
  onResetCompensationExpense: () => dispatch(resetFormCompensationExpense()),
  resetAdditionalExpense: () => dispatch(resetAdditionalExpense()),
  emailMeDocument: () => dispatch(emailMeDocument()),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);
const withReducer = injectReducer({
  key: 'stepCancellationAdditional',
  reducer,
});

export default compose(
  withReducer,
  withConnect
)(StepCancellationAdditional);



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepCancellationAdditional/index.js